<template>
  <v-select
    :value="value"
    :items="tags"
    item-text="name"
    item-value="id"
    :label="label"
    :placeholder="placeholder"
    :error-messages="errorMessages"
    :loading="loading"
    :dense="dense"
    :hide-details="hideDetails"
    :clearable="clearable"
    :outlined="outlined"
    multiple small-chips deletable-chips
    no-data-text="Тегов пока нет"
    @change="$emit('input', $event)"
  />
</template>

<script>
import { mapGetters } from 'vuex';

// Мультивыбор тегов из справочника. v-model — массив ID.
export default {
  name: 'CorpTagsSelect',
  props: {
    value: { type: Array, default: () => [] },
    label: { type: String, default: 'Теги' },
    placeholder: { type: String, default: '' },
    errorMessages: { type: [Array, String], default: () => [] },
    dense: { type: Boolean, default: true },
    outlined: { type: Boolean, default: true },
    clearable: { type: Boolean, default: true },
    hideDetails: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters({
      tags: 'users/corpClientTags/tags',
      loading: 'users/corpClientTags/loading',
    }),
  },
};
</script>
